import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';

import { DEFAULT_APPLICATION_PHONE_NUMBER, CLIENT_RELATIONS_PHONE_NUMBER } from 'src/app/features/shared/constants';

@Component({
  selector: 'app-nav-bar-session-ending',
  templateUrl: './nav-bar-session-ending.component.html',
  styleUrls: ['../nav-bar/nav-bar.component.scss'],
  standalone: false
})
export class NavBarSessionEndingComponent implements OnDestroy {
  clearSignSupportNumber = DEFAULT_APPLICATION_PHONE_NUMBER;
  private readonly subscription: Subscription;

  constructor(private readonly router: Router, private readonly route: ActivatedRoute) {
    this.subscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const childRoute = this.getDeepestChild(this.route);
        const product = childRoute.snapshot.data['productType'];

        if (childRoute.snapshot.data['title'] === 'Session End' && ['RemoteSigning', 'IPEN', 'Hybrid'].includes(product)) {
          this.clearSignSupportNumber = CLIENT_RELATIONS_PHONE_NUMBER;
        } else {
          this.clearSignSupportNumber = DEFAULT_APPLICATION_PHONE_NUMBER;
        }
      });
  }

  private getDeepestChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
